import microuniversoApi from "app/api/microuniversoApi";
import store from "app/redux/store/store";

declare var window: any

import globalMU from "globalMU";
import { IItemOrcamento } from "../../types/IItemOrcamento";

export type AlterarEntregaPosteriorItemParams = {
    identificador: number,
    check: boolean
}

export type AlterarEntregaPosteriorItemOutput = {
    status: "SUCESSO" | "ERRO"
}

export async function alterarEntregaPosteriorItem(params: AlterarEntregaPosteriorItemParams): Promise<AlterarEntregaPosteriorItemOutput> {
    try {
        globalMU.blockUI({ tryPassiveLoading: true })

        const orcamentoAtualizado = await microuniversoApi.Orcamento.definirEntregaPosteriorItemOrcamento(
            store.getState().orcamento.IdentificadorOrcamento,
            params.identificador, 
            params.check
        )

        const orcamentoLegado = window.orcamentoController.model

        orcamentoLegado.atualizar(orcamentoAtualizado)

        return {
            status: "HasErrors" in orcamentoAtualizado ? "ERRO" : "SUCESSO"
        }

    } finally {
        globalMU.unblockUI()
    }


}
